import styled from "styled-components"

import { SvgIcon } from "@components/common"

export const Icon = styled(SvgIcon)``
